<template>
  <div class="container app-wrapper">
    <head-index
      v-if="boo2 && headData && headData.length"
      class="cake-banner"
      :headData="headData"
      :form-context="cakeForm"
      :style="{ marginTop: '-1rem' }"
    ></head-index>
    <!-- 搜索浮在 Banner 上 -->
    <div class="cake-top-layer">
      <van-sticky :offset-top="0">
        <head-child class="themed-top-search" :change="true" :theme-color="bannerThemeColor" no-right>
          <template #left>
            <div class="themed-top-search__location" @click="Switch">
              <van-icon name="location-o" size="0.9rem" />
              <span class="themed-top-search__location-text ellipsis">{{ address || '定位中' }}</span>
              <van-icon name="arrow-down" size="0.65rem" />
            </div>
          </template>
          <template #middle>
            <van-search
              v-model="value"
              class="themed-top-search__input"
              placeholder="搜索商品"
              shape="round"
              background="transparent"
              readonly
              @focus="seach1"
            />
          </template>
          <template #right>
            <div class="themed-top-search__service" aria-label="在线客服" @click="openCustomerService">
              <van-icon name="service-o" size="1.4rem" />
            </div>
          </template>
        </head-child>
      </van-sticky>
    </div>
    <!-- 正常页面 -->
    <div v-if="boo2" class="cake-body">
      <!-- 公告在 Banner 下方 -->
      <platform-notice-bar page-code="cake_home" />
      <div class="cake-content">
        <lable-image
          v-if="topActivities.length"
          ref="activityTop"
          :data-list="topActivities"
          :form-context="cakeForm"
          zone="top"
          page-key="CakaHome"
          section-key="activityTop"
        />
        <nav-image
          v-if="category && category.length"
          ref="navGrid"
          :category="category"
          :form-context="cakeForm"
          page-key="CakaHome"
          section-key="navGrid"
        />
        <lable-image
          v-if="bottomActivities.length"
          ref="activityBottom"
          :data-list="bottomActivities"
          :form-context="cakeForm"
          zone="bottom"
          page-key="CakaHome"
          section-key="activityBottom"
        />
        <div class="cake-d-zone">
          <van-sticky :offset-top="48">
            <!-- <van-tabs @click="getTabIndex" v-model="navIndex">
              <van-tab v-for="(item, index) in dquData" :title="item.name" :key="index" />
            </van-tabs> -->
            <CakaTab  :title="dquData" ref="firstTab" @scrollToAll="getTabIndex"></CakaTab>
          </van-sticky>
          <van-list v-model="loading2" :finished="finished" finished-text="没有更多了" @load="nextPage">
            <goods-list-com :DataList="list"> </goods-list-com>
          </van-list>
        </div>
      </div>
    </div>
    <!-- 搜索页面 -->
    <seachview v-else ref="seach" style="margin-top: 3rem;" :value="value" @value="seachvalue" :type="1"></seachview>
    <!-- </van-pull-refresh> -->
    <!-- 引入定位组件并监听定位完成事件 -->
    <LocationComponent @location-finish="onLocationFinish" />
  </div>
</template>

<script>
import { Toast } from "vant";
import HeadChild from "../../components/HeadChild";
import NavImage from "../../components/cake/NavImage.vue";
import LableImage from "../../components/cake/LableImage.vue";
import HeadIndex from "../../components/index/HeadIndex.vue";
import Seachview from "../../components/index/Seachview.vue";
import GoodsListCom from "../../components/GoodsListCom.vue";
import CakaTab from "../../components/cake/CakaTab.vue";
import LocationComponent from '@/components/map/Location.vue';
import { mapState } from 'vuex';
import { HOME_DEFAULT_TOP_COLOR } from '@/utils/themeColor';
import { splitActivities } from '@/utils/mallHome';
import { openCustomerService } from '@/utils/customerService';
import PlatformNoticeBar from '@/components/PlatformNoticeBar.vue';
import {
  PAGE_KEYS,
  SECTION_KEYS,
  consumePageViewState,
  getWindowScrollTop,
  isPageViewRestorePending,
  restorePageViewState,
  savePageViewState,
  shouldPreserveViewState,
} from '@/utils/pageScrollRestore';
let initViewfinish = false

export default {
  name: "Home",
  props: {},
  data() {
    return {
      list: [],
      loading2: false,
      finished: false,
      category: [],
      cakeForm: {
        cardId: '',
        current: 1, // 当前页码
        size: 10, // 每页个数
        category1Id: '',
        category2Id: '',
        cityCode: '',
        upgradeFlag: '',
        bathId: '',
        id: '',
        hotType: '',
      },
      value: null,
      boo2: true,
      boo3: true,
      headData: [],
      lableData: [],
      dquData: [],
      upgradeFlag: '',
      bathId: '',
      // 标记是否已加载数据
      dataLoaded: false,
      bannerThemeColor: HOME_DEFAULT_TOP_COLOR,
    };
  },
  components: {
    NavImage,
    HeadChild,
    Seachview,
    HeadIndex,
    LableImage,
    GoodsListCom,
    CakaTab,
    LocationComponent,
    PlatformNoticeBar,
  },
  methods: {
    /** 活动/Banner 点击 queryTopicBooleanAndCategory 所需卡/城市上下文 */
    syncCakeFormContext() {
      this.cakeForm.cardId = localStorage.getItem('cardId') || '';
      this.cakeForm.bathId = localStorage.getItem('bathId') || '';
      this.cakeForm.upgradeFlag = localStorage.getItem('upgradeFlag') || '';
      this.cakeForm.cityCode = this.cityCode || localStorage.getItem('cityCode') || '';
    },
    getBanner() {
      let form = {
        cardId: this.cakeForm.cardId,
        cityCode: this.cityCode,
        upgradeFlag: this.upgradeFlag,
        bathId: this.bathId,
        hotType: "A",
        showPositionCode: "1"
      }

      this.$api
        .getQueryRotation(form)
        .then((res) => {
          this.headData = Array.isArray(res.data) ? res.data : [];
          const first = this.headData[0]
          if (first && first.themeColor) {
            this.bannerThemeColor = first.themeColor
          }
        })
        .catch((err) => {
        });
    },
    getQueryRotation() {
      let form = {
        cardId: this.cakeForm.cardId,
        cityCode: this.cityCode,
        upgradeFlag: this.upgradeFlag,
        bathId: this.bathId,
        hotType: "D",
        showPositionCode: "1"
      }
      this.$api
        .getQueryRotation(form)
        .then((res) => {
          // this.category = res.data
          this.category = []
          this.dquData = []
          if (res.data) {
            res.data.forEach((element) => {
              if (!element.showImgId) {
                return;
              }
              if (element.region === 'B') {
                this.category.push(element);
              } else if (element.region === 'D') {
                this.dquData.push({
                  name: element.name,
                  description: element.description,
                  id: element.showImgId.id,
                });
              }
            });
            if (this.dquData.length > 0) {
              this.cakeForm.id = this.dquData[0].id;
              this.cakeForm.hotType = 'D';
              this.getGoodList();
            }
          }
          // this.getData()
        })
        .catch((err) => {
        });
    },
    getGoodList() {
      this.cakeForm.cityCode = this.cityCode
      this.cakeForm.bathId = this.bathId
      this.cakeForm.upgradeFlag = this.upgradeFlag
      this.$api
        .queryProductInfoHomeNew(this.cakeForm)
        .then((res) => {
          if (res.code == 1) {
            Toast(res.msg)
            this.loading2 = false
            return
          }
          if (this.cakeForm.current == 1) {
            this.list = res.data.records
          } else {
            this.list.push(...res.data.records)
          }
          this.loading2 = false;
          if (this.cakeForm.current >= res.data.pages) {
            this.finished = true
          }

        })
        .catch((err) => {
          this.loading2 = false;
        });
    },
    nextPage() {
      if (this.list.length >= 10) {
        this.cakeForm.current += 1
        this.getGoodList()
      } else {
        this.loading2 = false
      }
    },
    getTabIndex(index) {
      this.cakeForm.id = this.dquData[index].id
      this.cakeForm.category2Id = ''
      this.cakeForm.hotType = 'D'
      this.cakeForm.current = 1
      this.finished = false

      var timer = setInterval(() => {
        this.getGoodList()
        clearInterval(timer);
      }, 300)
    },
    getQueryLabel() {
      let form = {
        cardId: this.cakeForm.cardId,
        cityCode: this.cityCode,
        upgradeFlag: this.upgradeFlag,
        bathId: this.bathId,
        hotType: "B",
        showPositionCode: "1"
      }

      this.$api
        .getQueryRotation(form)
        .then((res) => {
          this.lableData = Array.isArray(res.data) ? res.data : []
        })
        .catch((err) => {
        });
    },
    // 位置选择
    Switch() {
      // this.$router.push("Classification");
      this.$router.push("SelectAdderss");
    },
    // 顶部搜索栏客服入口
    openCustomerService,
    // 调用子组件的方法
    seach() {
      this.$refs.seach.seach(this.value);
      this.boo3 = false;
    },
    // 输入框获取焦点
    seach1() {
      this.$router.push({ name: 'SearchGoods' })
    },

    // 返回
    goback() {
      this.boo2 = true;
      this.value = null
    },
    //子组件分发的事件  点击历史记录重新给输入框赋值
    seachvalue(val) {
      this.value = val;
    },
    initView() {
      // 如果已经加载过数据，不再重复加载
      if (this.dataLoaded) {
        return;
      }
      // 标记数据已加载
      this.dataLoaded = true;
      
      this.value = null
      this.boo2 = true
      this.upgradeFlag = localStorage.getItem("upgradeFlag");
      this.bathId = localStorage.getItem("bathId");
      this.syncCakeFormContext();
      if(!this.cityCode) {
        return;
      }
      this.getBanner()
      this.getQueryLabel()
      this.getQueryRotation()

    },
    /**
     * 定位完成后的回调
     * @param {Object} locationInfo 定位信息
     */
    onLocationFinish() {
      this.dataLoaded = false;
      this.initView();
    }
  },
  activated() {
    if (!isPageViewRestorePending(PAGE_KEYS.CAKA_HOME)) return;
    this.$nextTick(() => {
      restorePageViewState(PAGE_KEYS.CAKA_HOME, {
        [SECTION_KEYS.ACTIVITY_TOP]: (left) => {
          if (this.$refs.activityTop) this.$refs.activityTop.setScrollLeft(left);
        },
        [SECTION_KEYS.ACTIVITY_BOTTOM]: (left) => {
          if (this.$refs.activityBottom) this.$refs.activityBottom.setScrollLeft(left);
        },
        [SECTION_KEYS.NAV_GRID]: (left) => {
          if (this.$refs.navGrid) this.$refs.navGrid.setScrollLeft(left);
        },
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    if (shouldPreserveViewState(to.path)) {
      savePageViewState(PAGE_KEYS.CAKA_HOME, {
        scrollTop: getWindowScrollTop(),
        sections: {
          [SECTION_KEYS.ACTIVITY_TOP]: this.$refs.activityTop
            ? this.$refs.activityTop.getScrollLeft() : 0,
          [SECTION_KEYS.ACTIVITY_BOTTOM]: this.$refs.activityBottom
            ? this.$refs.activityBottom.getScrollLeft() : 0,
          [SECTION_KEYS.NAV_GRID]: this.$refs.navGrid
            ? this.$refs.navGrid.getScrollLeft() : 0,
        },
      });
    } else {
      consumePageViewState(PAGE_KEYS.CAKA_HOME);
    }
    next();
  },

  beforeRouteEnter(to, from, next) {
    to.meta.keepAlive = true
    const isDetail = /^\/Details/i.test(from.path);
    if (!isDetail && from.path !== "/SearchGoods") {
      next((vm) => {
        vm.$nextTick(() => {
          vm.initView()
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0
        })
      });
    } else {
      initViewfinish = true
      next();
    }
  },
  created() {
    if (initViewfinish) {
      initViewfinish = false
      this.initView()
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0
    }
  },

  // beforeRouteLeave(to, from, next) {
  //   if (to.path === '/Details') {
  //     from.meta.keepAlive = true
  //   } else {
  //     from.meta.keepAlive = false
  //   }
  //   next()
  // },
  computed: {
    ...mapState({
      address: state => state.address,
      cityCode: state => state.cityCode
    }),
    activitySplit() {
      return splitActivities(this.lableData);
    },
    /** Banner下：1 全宽 | ≥2 各 50%（与商城 C 区一致） */
    topActivities() {
      return this.activitySplit.top;
    },
    /** 宫格下：第 3 个起（与商城 C 区一致） */
    bottomActivities() {
      return this.activitySplit.bottom;
    },
  },
  watch: {
    // 输入框的值
    value(val, oldval) {
      if (oldval !== "") {
        this.boo3 = true;
      }
    },
    // 监听城市代码变化
    cityCode(newVal, oldVal) {
      if (newVal) {
        this.cakeForm.cityCode = newVal;
      }
      if (newVal && newVal !== oldVal) {
        // 标记数据未加载
        this.dataLoaded = false;
      }
    },
    '$route'() {
      this.dataLoaded = false;
    }
  },

};
</script>

<style lang='scss' scoped>
.cake-banner {
  height: 16rem;
  overflow: hidden;
}

/* 搜索浮在 Banner 上，不被 cake-body 盖住 */
.cake-top-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3;
}

/*
 * Banner 高度 16rem + marginTop -1rem，视觉底边在 15rem。
 * cake-body 必须对齐视觉底边，否则公告与 Banner 之间会空出约 1rem。
 */
.cake-body {
  position: absolute;
  top: 15rem;
  z-index: 1;
  width: 100%;
  box-sizing: border-box;
}

/* 通栏 Banner 下：去掉公告顶间距，只保留左右留白 */
.cake-body :deep(.platform-notice) {
  padding-top: 0;
}

::v-deep .cake-banner .my-swipe,
::v-deep .cake-banner .img {
  border-radius: 0 !important;
}

.cake-content {
  background-color: #F5F5F5;
  padding: 0.5rem 0.5rem 3rem;
  border-top-right-radius: 0.75rem;
  border-top-left-radius: 0.75rem;
  margin-top: -0.5rem;
  overflow: hidden;
  box-sizing: border-box;
}

.cake-d-zone {
  margin-top: 0.2rem;
  background: #fff;
  border-radius: 0.4rem;
  overflow: hidden;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);

  ::v-deep .grid-container {
    padding-left: 0;
    padding-right: 0;
  }

  ::v-deep .van-sticky {
    margin-bottom: 0;
  }

  ::v-deep .van-sticky--fixed {
    background: #fff;
  }
}
</style>

<style lang="scss" scoped>
@import '@/styles/themedTopSearch.scss';
</style>